<template>
  <div class="container">
    <div class="row text-center mb-3">
      <div class="col-md-12">
        <h3 class="display-5">My Skills</h3>
      </div>
      <div class="col-md-4">
        <img
          src="../../assets/images/undraw_proud_coder_7ain.png"
          style="width:100%"
        />
      </div>
      <div class="col-md-8 mt-1 py-1">
        <div class="row">
          <div
            class="col-md-2 col-4 mt-1 py-0 text-center"
            v-for="(item, index) in data1.skills"
            :key="index"
          >
            <img :src="item.url" class="my-2 logos" />
            {{item.level}}
          </div>
        </div>
      </div>
    </div>

    <hr />
  </div>
</template>

<script>
import data1 from "@/assets/data/skills.json";
export default {
  name: "skill",
  data: () => ({
    data1,
  }),
};
</script>
<style>
.logos {
  width: 12vh;
  border-radius: 7px;
  padding:18%;
  border: 1px solid #e0e0e0;
  height: 12vh;
}
</style>
